import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CommonTabs from "@/shared/components/ui/Tabs/Tabs";
import { SettingTabs } from "@/shared/utils/utils";
import IntegrationSettings from "@/features/settings/IntegrationSettings";
import DeliverabilitySettings from "@/features/settings/DeliverabilitySettings";
import CompanyProfile from "@/features/onboarding/components/Onboarding/CompanyProfile";
import OpenAIKeySettings from "@/features/settings/OpenAIKeySettings";
import VoiceSettings from "@/features/voice/components/VoiceSettings";
import { useMainStore } from "@/stores";
import { USER_ROLES } from "@/shared/utils/constants";

export default function Settings() {
  const { tab } = useParams();
  const navigate = useNavigate();

  const user = useMainStore((state) => state.user);

  // ONLY org admin + bring_your_own_llm
  const canViewOpenAIKeyTab =
    user?.organization_llm_type === "bring_your_own_llm" &&
    (user?.role === USER_ROLES.ORG_ADMIN ||
      user?.role === USER_ROLES.SUPER_ADMIN ||
      user?.role === USER_ROLES.SUPER_ADMIN_ALT);

  const visibleTabs = SettingTabs.filter((t) => {
    if (t.key === "api_key") {
      return canViewOpenAIKeyTab;
    }

    return (
      !t.adminOnly ||
      user?.role === USER_ROLES.ORG_ADMIN ||
      user?.role === USER_ROLES.SUPER_ADMIN ||
      user?.role === USER_ROLES.SUPER_ADMIN_ALT
    );
  });

  useEffect(() => {
    if (tab === "api_key" && !canViewOpenAIKeyTab) {
      navigate("/settings/integrations", { replace: true });
    }
  }, [canViewOpenAIKeyTab, navigate, tab]);

  const handleTabClick = (newTab) => {
    navigate(`/settings/${newTab}`);
  };

  return (
    <div className="flex flex-col gap-4 w-full px-4">
      <h1 className="text-[1.375rem] text-gray-800 dark:text-gray-100 font-bold">Settings</h1>

      {/* tabs with tab content */}
      <div className="w-full">
        <div className="flex flex-col w-full">
          <CommonTabs
            tab={tab}
            handleTabClick={handleTabClick}
            tabs={visibleTabs}
          />

          <div
            className={`p-4 shadow-sm rounded-b-[16px] ${tab?.toLowerCase() === "integrations"
                ? "rounded-tr-[16px] rounded-tl-none"
                : "rounded-t-[16px]"
              } bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 w-full scrollbar-hide`}
          >
            {tab === "integrations" && <IntegrationSettings tab={tab} />}

            {tab === "deliverability" && <DeliverabilitySettings tab={tab} />}

            {tab === "company_profile" && <CompanyProfile tab={tab} />}

            {tab === "voice_ai" && <VoiceSettings tab={tab} />}

            {tab === "api_key" && canViewOpenAIKeyTab && (
              <OpenAIKeySettings tab={tab} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
